import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PasswordInput from '../../../PasswordInput';
import { validateFullName } from '../../../../formValidators';
import StyledTextField from '../../../common/StyledTextField';
var LazyFinish = /*#__PURE__*/function (_Component) {
  function LazyFinish(props) {
    var _this;
    _classCallCheck(this, LazyFinish);
    _this = _callSuper(this, LazyFinish, [props]);
    _this.state = {
      fullName: '',
      password: '',
      submitted: false,
      errors: {}
    };
    _this.handleUpdateField = _this.handleUpdateField.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _inherits(LazyFinish, _Component);
  return _createClass(LazyFinish, [{
    key: "handleValidate",
    value: function handleValidate() {
      var _this$state = this.state,
        fullName = _this$state.fullName,
        password = _this$state.password,
        termsCheckbox = _this$state.termsCheckbox,
        errors = _this$state.errors;
      var fullNameValidation = validateFullName(fullName);
      this.setState({
        errors: _objectSpread(_objectSpread({}, errors), {}, {
          fullName: fullNameValidation.error,
          password: password.length ? null : 'Please fill out this field.',
          termsCheckbox: termsCheckbox ? null : 'Please check this box if you want to proceed.'
        })
      });
      return fullNameValidation.isValid && password.length && termsCheckbox;
    }
  }, {
    key: "handleUpdateField",
    value: function handleUpdateField(field) {
      var _this2 = this;
      return function (e) {
        return _this2.setState(_defineProperty({}, field, field === 'termsCheckbox' ? e.target.checked : e.target.value));
      };
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      if (this.handleValidate()) {
        this.setState({
          submitted: true
        });
      } else {
        e.preventDefault();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        onboardType = _this$props.onboardType;
      var _this$state2 = this.state,
        fullName = _this$state2.fullName,
        submitted = _this$state2.submitted,
        errors = _this$state2.errors,
        termsCheckbox = _this$state2.termsCheckbox;
      return /*#__PURE__*/React.createElement("div", {
        className: "finish-container style-guide"
      }, /*#__PURE__*/React.createElement("div", {
        className: "lazy-finish"
      }, /*#__PURE__*/React.createElement("h1", null, "Set your password to start your application!"), /*#__PURE__*/React.createElement("div", {
        className: "lazy-finish-child"
      }, /*#__PURE__*/React.createElement("form", {
        id: "create_consultant",
        className: "edit_user",
        action: "/users/finish-onboarding",
        acceptCharset: "UTF-8",
        method: "post",
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "authenticity_token",
        value: csrfToken
      }), /*#__PURE__*/React.createElement(StyledTextField, {
        id: "full_name",
        className: "form-control fs-hide",
        value: fullName,
        error: !!errors.fullName,
        helperText: errors.fullName,
        onChange: this.handleUpdateField('fullName'),
        name: "user[full_name]",
        label: "Full Name",
        type: "text"
      }), /*#__PURE__*/React.createElement(PasswordInput, {
        errors: errors.password,
        title: "Password",
        handleChange: this.handleUpdateField('password')
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("input", {
        className: "form-control terms-and-privacy-checkbox",
        type: "checkbox",
        name: "user[terms_and_privacy_consent]",
        id: "terms-and-privacy-checkbox",
        tabIndex: "0",
        value: termsCheckbox,
        onChange: this.handleUpdateField('termsCheckbox')
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "consultant-terms-and-privacy-consent",
        className: "ms-2 terms-and-privacy-checkbox body-text-2 regular"
      }, "I agree to Clora's", /*#__PURE__*/React.createElement("a", {
        href: "/terms-of-use"
      }, " Terms of Use"), ' ', "and", /*#__PURE__*/React.createElement("a", {
        href: "/privacy-policy"
      }, " Privacy Policy"), "."), errors.termsCheckbox ? /*#__PURE__*/React.createElement("p", {
        className: "error-text"
      }, errors.termsCheckbox) : ''), /*#__PURE__*/React.createElement("div", {
        className: "actions mt-4"
      }, /*#__PURE__*/React.createElement("button", {
        type: "submit",
        name: "commit",
        id: "".concat(onboardType, "-consultant-sign-up"),
        className: "btn btn-primary full-width",
        disabled: submitted,
        tabIndex: "0"
      }, "Set Password"))))));
    }
  }]);
}(Component);
LazyFinish.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  onboardType: PropTypes.string.isRequired
};
export default LazyFinish;